import styles from './CopyComplexesLoader.scss'

export const CopyComplexesLoader = () => (
  <div className={styles.copyProgress} role="status">
    <span>{'Выполняется копирование комплектов'}</span>
    <span className={styles.root} aria-hidden="true">
      {Array.from({ length: 8 }).map((_, index) => (
        <span className={styles.item} key={index} />
      ))}
    </span>
  </div>
)
